import React from 'react';

const QUEUE_OPTIONS = [
  { key: 'pending', label: 'Pending' },
  { key: 'review needed', label: 'Review Needed' },
  { key: 'approved', label: 'Approved' },
  { key: 'denied', label: 'Denied' }
];

function RequestQueueTabs({ selectedQueue, summary, onSelect, includeAll = false, allLabel = 'All Requests' }) {
  const queueOptions = includeAll
    ? [{ key: 'all', label: allLabel }, ...QUEUE_OPTIONS]
    : QUEUE_OPTIONS;

  return (
    <div className="request-queue-tabs" role="tablist" aria-label="Request queues">
      {queueOptions.map((option) => (
        <button
          key={option.key}
          type="button"
          role="tab"
          aria-selected={selectedQueue === option.key}
          className={`request-queue-tab ${selectedQueue === option.key ? 'active' : ''}`}
          onClick={() => onSelect(option.key)}
        >
          <span>{option.label}</span>
          <strong>
            {option.key === 'all'
              ? summary.all || 0
              : option.key === 'review needed'
              ? summary.reviewNeeded
              : summary[option.key] || 0}
          </strong>
        </button>
      ))}
    </div>
  );
}

export default RequestQueueTabs;
